/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const EyeIcon = /*#__PURE__*/ createSvgIcon(
  'EyeIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M10 13.5c.972 0 1.799-.34 2.48-1.02.68-.681 1.02-1.508 1.02-2.48s-.34-1.799-1.02-2.48C11.798 6.84 10.971 6.5 10 6.5s-1.799.34-2.48 1.02C6.84 8.202 6.5 9.029 6.5 10s.34 1.799 1.02 2.48c.681.68 1.508 1.02 2.48 1.02zm0-1.5a1.929 1.929 0 01-1.417-.583A1.929 1.929 0 018 10c0-.556.195-1.028.583-1.417A1.929 1.929 0 0110 8c.556 0 1.028.194 1.417.583.389.39.583.861.583 1.417s-.194 1.028-.583 1.417A1.928 1.928 0 0110 12zm0 4a9.078 9.078 0 01-4.98-1.448 10.637 10.637 0 01-3.603-3.823 1.13 1.13 0 01-.146-.35 1.682 1.682 0 010-.754c.028-.125.076-.243.146-.354A10.636 10.636 0 015.02 5.448 9.078 9.078 0 0110 4c1.805 0 3.464.483 4.978 1.448a10.636 10.636 0 013.604 3.823c.07.11.119.227.146.35a1.68 1.68 0 010 .754 1.121 1.121 0 01-.146.354 10.637 10.637 0 01-3.604 3.823A9.077 9.077 0 0110 16zm0-1.5a8.123 8.123 0 004.313-1.208A8.085 8.085 0 0017.354 10a8.085 8.085 0 00-3.041-3.292A8.123 8.123 0 0010 5.5a8.123 8.123 0 00-4.312 1.208A8.085 8.085 0 002.646 10a8.085 8.085 0 003.042 3.292A8.123 8.123 0 0010 14.5z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default EyeIcon;
